import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { Account } from 'src/app/core/auth/account.model';
import { AccountService } from 'src/app/core/auth/account.service';
import { AuthServerProvider } from 'src/app/core/auth/auth-jwt.service';
import { Login } from './login.model';

@Injectable({
  providedIn: 'root'
})
export class SigninService {
  constructor(private accountService: AccountService, private authServerProvider: AuthServerProvider) { }

  login(credentials: Login): Observable<Account> {
    return from(this.authServerProvider.login(credentials)).pipe(
      mergeMap((account: Account | null) => {
        if (account) {
          return [account];
        } else {
          throw new Error('Login failed');
        }
      })
    );
  }

  logout(): void {
    this.authServerProvider.logout().subscribe({ complete: () => this.accountService.authenticate(null) });
  }

  forgotPassword(credentials: Login): Observable<any> {
   return this.authServerProvider.forgotPassword(credentials);
 }

}
